<!-- eslint-disable vue/valid-template-root -->

<template>
      <Col v-if="$hasPermission(mdmObj.permission)">
        <div @click="routeTo(mdmObj)" class="card-gradient pointer is-hover">
          <h3 class="d-flex justify-content-between">
            <span class="text-lg">
              {{mdmObj.tlabel ? $t(mdmObj.tlabel) : mdmObj.name }}
            </span>
            <div class="d-flex align-item-center ml-auto" v-if="showCounts"> <!-- is-hover ***Future Implementation*** -->
              <span class="box-inner">
                <!-- <span class="label-hidden">Download</span> ***Future Implementation*** -->
                <span class="box-radius">
                  <svgicon name="icon-records" width="14" height="14" />
                </span>
              </span>
              <span class="text-md">
                <Spinner v-if="isLoading" class="spinner--circle-1" style="width:20px;height:20px;border-width:3px !important;"/>
                <span v-else>{{validCount >= 0 ? validCount : '-'}}</span>
              </span>
            </div>
          </h3>
          <div class="card-body d-flex" v-if="invalidPresent && showCounts">
            <div class="d-flex ml-auto align-item-center"> <!-- is-hover hover-red    ***Future Implementation*** -->
              <span class="box-inner">
                <!-- <span class="label-hidden">Download</span> ***Future Implementation*** -->
                <span class="box-radius border-grey">
                  <svgicon name="icon-details" width="14" height="14" />
                </span>
              </span>
              <span class="text-md text-bold text-grey1">
                {{invalidCount}}
              </span>
            </div>
          </div>
        </div>
      </Col>
</template>

<script>
import { modelMapper, bfrMapper } from '../../../constants/mdm-v2/pageConstants';

export default {
  data() {
    return {
      isLoading: true,
      validCount: 0,
      invalidCount: 0,
      invalidPresent: false,
      modelMapper,
    };
  },
  props: {
    mdmObj: { type: Object },
    showCounts: {
      type: Boolean,
      default: false,
    },
    openInNewTab: { type: Boolean },
  },
  methods: {
    async getCount(showCounts) {
      try {
        if (showCounts && !this.validCount) {
          const mdmCount = await this.$store.dispatch('mdm/fetchCount', this.modelMapper[this.mdmObj.id]);
          if (mdmCount.valid) {
            this.validCount = mdmCount.valid;
            this.invalidCount = mdmCount.invalid;
            this.invalidPresent = true;
          } else {
            this.validCount = mdmCount.count ? mdmCount.count : 0;
          }
        }
      } catch (error) {
        throw error;
      }
      this.isLoading = false;
    },
    routeTo(mdmObj) {
      const routerId = bfrMapper[mdmObj.id] || mdmObj.id;
      if (this.openInNewTab) {
        const route = this.$router.resolve({ name: routerId });
        window.open(route.href, '_blank');
      } else {
        this.$router.push({ name: routerId });
      }
    },
  },
  watch: {
    showCounts(isShow) {
      this.getCount(isShow);
    },
  },
};
</script>
